import React from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect, useState } from "react";
import {
  Box,  
  CssBaseline,
} from "@mui/material";
import { useFormik } from "formik";
import NavbarComponent from "../component/navbar-component";
import dayjs from "dayjs";
import "dayjs/locale/id";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import ModeSelector from "../component/reservasi-mode-component";
import ReservationForm from "../component/reservasi-form-component";

const boxVariant = {
  visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
  hidden: { opacity: 0, scale: 1 },
};

const BoxAnimate = ({ component }) => {
  // State definition
  const control = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);

  return (
    <motion.div
      className="box"
      ref={ref}
      variants={boxVariant}
      initial="hidden"
      animate={control}
    >
      {component}
    </motion.div>
  );
};

const FormDataPelanggan = () => {
  const navigate = useNavigate();

  // State definition
  const [pickValue, setPickValue] = useState(dayjs().add(1, "day"));
  const [outlets, setOutlets] = useState([]);
  const [reservationType, setReservationType] = useState(null);

  // ===== UseEffect Function =====
  useEffect(() => {
    const savedReservation = localStorage.getItem("reservationData");
    const savedReservation_parsed = JSON.parse(savedReservation);
    if (savedReservation_parsed) {
      formik.setFieldValue("order_person", savedReservation_parsed?.order_person);
      formik.setFieldValue("phone", savedReservation_parsed?.phone);
      formik.setFieldValue("seat", savedReservation_parsed?.seat);
      formik.setFieldValue("outletId", savedReservation_parsed?.outletId);
      formik.setFieldValue("pack", savedReservation_parsed?.pack);
      formik.setFieldValue("address", savedReservation_parsed?.address);
    }

    // Get data Outlet
    axios({
        method: "get",
        url: `https://script.google.com/macros/s/AKfycbwMR-2Dk9gpd5_KlmhL1Lgk_opPU6OOzb-KJQjizlRtYpKtX_Bp7QWa4i172CDKoRbE/exec?api=outlet`,     
      })
      .then((response) => {
        const rawData = response.data;
        setOutlets(rawData.data);
      })
      .catch((err) => {});
  }, []);  

  const formik = useFormik({
    initialValues: {
      order_person: "",
      phone: "",
      order_date: dayjs().add(1, "day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      seat: 4,
      outletId: 1,
      pack: 25,
      address: ""
    },
    onSubmit: (values) => {          
      let payload;

      // ===== VALIDASI =====
      if (reservationType === "dinein" && values.seat < 4) {
        Swal.fire({
          icon: "error",
          title: `Mohon Maaf 🙏`,
          html: `<small> Minimum reservasi dine in adalah 4 orang </small>`,
        });
        return;
      }

      // if (reservationType === "catering" && values.pack < 25) {
      //   Swal.fire({
      //     icon: "error",
      //     title: `Mohon Maaf 🙏`,
      //     html: `<small> Minimum catering adalah 25 pack </small>`,
      //   });
      //   return;
      // }

      if (reservationType === "catering") {
        if (Number(formik.values.pack) < 24) {
          Swal.fire({
            icon: "error",
            title: `Mohon Maaf 🙏`,
            html: `<small> Minimum catering adalah 25 pack </small>`,
          });
          return;
        }

        const orderDate = dayjs(formik.values.order_date);
        if (orderDate.diff(dayjs(), "day") < 1) {          
          Swal.fire({
            icon: "error",
            title: `Mohon Maaf 🙏`,
            html: `<small> Reservasi catering minimal dilakukan H-1 sebelum pengiriman. </small>`,
          });
          return;
        }
      }

       // ===== PAYLOAD BUILDER =====
      if (reservationType === "dinein") {
        payload = {
          type: "dinein",
          order_person: values.order_person,
          phone: `+62${values.phone}`,
          seat: values.seat,
          outletId: values.outletId,
          order_date: values.order_date,
        };
      }

      if (reservationType === "catering") {
        payload = {
          type: "catering",
          order_person: values.order_person,
          phone: `+62${values.phone}`,
          pack: values.pack,   
          address: values.address,
          order_date: values.order_date,
        };
      }

      // ===== SIMPAN & NAVIGATE =====
      localStorage.setItem("reservationData", JSON.stringify(payload));

      navigate("/menu", {
        state: payload,
      });      
    },
  });

  return (
    <div>
      <CssBaseline />
      <BoxAnimate component={<NavbarComponent />} />

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        mt={4}
      >
        {!reservationType && (
          <ModeSelector onSelect={setReservationType} />
        )}

        {reservationType && (
          <ReservationForm
            type={reservationType}
            onBack={() => setReservationType(null)}
            formik={formik}
            outlets={outlets}
            pickValue={pickValue}
            setPickValue={setPickValue}            
          />
        )}
      </Box>
    </div>
  );
};

export default FormDataPelanggan;
